var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zwl-tab",style:({color: _vm.active ? _vm.themeColor : ''}),on:{"click":_vm.changeTab}},[(_vm.type !== 'search')?_c('div',[_vm._v(_vm._s(_vm.tab.name))]):_c('i',{staticClass:"iconfont icon-sousuo"})])}
var staticRenderFns = []

export { render, staticRenderFns }